import React from 'react';
import { ToastContainer } from 'react-toastify';
import MainSalarySimPage from './components/MainPage';
import { ConfigContextProvider } from './Context/ConfigContext';
import { SalarySimContextProvider } from './Context/SalarySimContext';
import { TranslationContextProvider } from './Context/TranslationContext';
import { CodeListContextProvider } from './Context/CodeListContext';

import 'react-toastify/dist/ReactToastify.css';
import './css/normalize.css';
import './css/webflow.css';
import './css/salarysimwebflow.css';
import './css/salarysimwebflow_custom.css';
import './css/salarysim.css';
import { ToastContextProvider } from './Context/ToastContext';
import { LicenseInfo } from '@mui/x-license-pro';
LicenseInfo.setLicenseKey('140108934b60b94a9c03b2cb71536b62Tz02NDI0OSxFPTE3MTM1MzMyNjEyMzQsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=');

function App() {

  return (
    <>
      <ConfigContextProvider>
        <ToastContextProvider>
          <TranslationContextProvider>
            <CodeListContextProvider>
              <SalarySimContextProvider>
                <MainSalarySimPage />
              </SalarySimContextProvider>
            </CodeListContextProvider>
          </TranslationContextProvider>
        </ToastContextProvider>
      </ConfigContextProvider>

    </>
  );
}

export default App;
